export const MENSAJES_SISTEMA_SHOW = 'MENSAJES_SISTEMA_SHOW';